'use client';

import { useEffect } from 'react';

/**
 * Injects a style rule into the voltax-player's shadow DOM within the
 * `.stn-video-player` container whose class contains the given target string.
 * Attaches a MutationObserver to handle the player loading asynchronously.
 */
export function useHideStnPlaylist(target: string) {
  useEffect(() => {
    const container = document.querySelector(`.stn-video-player[class*="${target}"]`);
    if (!container) {
      return;
    }

    const hideStnPlaylist = () => {
      const shadowRoot = container.querySelector('voltax-player')?.shadowRoot;
      if (!shadowRoot || shadowRoot.querySelector('#hide-stn-playlist')) {
        return;
      }

      const style = document.createElement('style');
      style.id = 'hide-stn-playlist';
      style.textContent = '.playlistContainer { visibility: hidden !important; pointer-events: none !important; }';
      shadowRoot.appendChild(style);
    };

    const observer = new MutationObserver(hideStnPlaylist);
    observer.observe(container, { childList: true, subtree: true });
    hideStnPlaylist();

    return () => observer.disconnect();
  }, [target]);
}
